// Read-only projection of the ordered, authoritative round results.
const key = value => String(value || '').toLowerCase();
function duelRoundProgress(series, gameId, username) {
  const players = series?.players || [];
  const me = players.find(p => key(p) === key(username));
  const other = players.find(p => p !== me);
  const index = (series?.rounds || []).findIndex(r => r.gameId === gameId);
  if (!me || !other || index < 0) return null;
  const wins = Object.fromEntries(players.map(p => [p, 0]));
  for (const round of series.rounds.slice(0, index + 1)) {
    const winner = players.find(p => key(p) === key(round.winner));
    if (winner && !round.isDraw) wins[winner]++;
  }
  return { number: series.rounds[index].number || index + 1, mine: wins[me], opponent: wins[other], draw: Boolean(series.rounds[index].isDraw), won: wins[me] === 3, lost: wins[other] === 3 };
}
module.exports = {duelRoundProgress};
